import { ScheduleMode } from './course';
// 表格数据类型
export interface ListResponse<T> {
  total: number;
  list: T[];
  url?: string;
  message?: string; // 消息
}

// 课时统计数据类型
export interface TeacherClassTimeStatistics<T> {
  total: number;
  total_count: number;
  total_fee: number;
  list: T[];
  course_type_list: {
    course_schedule_type: ScheduleMode;
    course_type_id: number;
    course_type_name: string;
  }[];
}

// 性别枚举
export enum Gender {
  UNKNOWN = 0,
  MALE = 1, // 男
  FEMALE = 2, // 女
}

// 员工状态枚举
export enum EmploymentStatus {
  EMPLOYED = 1, // 在职
  RESIGNED = 2, // 离职
}

// 全兼职枚举
export enum JobStatus {
  FULL_TIME = 1, // 全职
  PART_TIME = 2, // 兼职
}

// 会员卡支付类型枚举
export enum PaymentType {
  TIMES = 1, // 按次
  DAY = 2, // 按天
}

// 课程难度等级枚举
export enum CourseDifficulty {
  EXTREMELY_SIMPLE = 1, // 极简
  SIMPLE = 2, // 简单
  MEDIUM = 3, // 适中
  INCREASE = 4, // 提升
  HARD = 5, // 较难
}

// 数据状态
export enum DataStatus {
  Active = 1, // 正常存在的数据
  Inactive = 2, // 下线/逻辑删除
}

// 是否启用某个功能
export enum EnableStatus {
  Enabled = 1, // 启用 / 开 / 是
  Disabled = 2, // 禁用 / 关 / 否
}
